/**
 * @format
 * Web entry point for chat-rn-app-frontend
 */

import { AppRegistry } from 'react-native';
import StackNavigator from './src/navigation/StackNavigator';

// Register the app
const APP_NAME = 'ChatRNApp';

AppRegistry.registerComponent(APP_NAME, () => StackNavigator);

// For web, render directly
const rootTag = document.getElementById('root');

if (rootTag) {
  AppRegistry.runApplication(APP_NAME, {
    rootTag,
  });
}

// Enable hot module replacement
if (module.hot) {
  module.hot.accept();
}
